import './translations/i18n'
import React from 'react';
import ReactDOM from 'react-dom';

import { Provider } from 'react-redux';
import { App } from './Application';
import { store } from './Store';
import './Application/AppTheme.less';
import { ErrorBoundary } from './Application/ErrorBoundary';
import { Telemetry } from '~/Services/Telemetry';

// [MVP Observability] Khởi tạo telemetry SDK (JS error, web vitals, page_view -> Telemetry API)
Telemetry.init();

ReactDOM.render(
  <ErrorBoundary>
    <Provider store={store}>
      <App />
    </Provider>
  </ErrorBoundary>,
  document.getElementById('app'),
);
